import { useState } from 'react';

export default function Testimonials() {
  const [activeFilter, setActiveFilter] = useState<'all' | 'house' | 'grave'>('all');

  const testimonials = [
    { category: '전원주택', categoryEn: 'house', rating: 5, headline: '주말마다 풀 베러 가던 시간이 사라졌어요', content: '금산면 전원주택을 구입했는데, 매주 풀 관리하러 가느라 정작 쉬지를 못했어요. 홈앤그레이브 정기 구독 후로는 정말 쉬러만 갑니다. 사계절 관리받으니 집이 항상 깔끔해요.', name: '박성호', info: '금산면 전원주택 소유' },
    { category: '전원주택', categoryEn: 'house', rating: 5, headline: '정원 관리가 이렇게 전문적일 줄이야', content: '단순 제초만 하는 줄 알았는데, 수목 진단부터 계절별 처방까지 해주시더라고요. 드론으로 정원 전체를 촬영해서 보내주니 관리 상태를 한눈에 확인할 수 있어요.', name: '이수진', info: '문산읍 세컨드하우스 소유' },
    { category: '전원주택', categoryEn: 'house', rating: 5, headline: '귀촌 후 가장 잘한 선택', content: '나이가 들어 직접 정원 관리가 힘들었는데, 홈앤그레이브가 우리 집 전담 주치의 같아요. GPS로 면적 재서 정확한 견적 주시고, 작업 후 보고서도 꼼꼼해요.', name: '최영수', info: '집현면 귀촌 거주' },
    { category: '산소', categoryEn: 'grave', rating: 5, headline: '서울 사는 딸이 대신 맡겼어요', content: '부모님 산소를 직접 관리하지 못해 늘 마음이 무거웠는데, 홈앤그레이브 덕분에 안심하고 있습니다. 드론 사진으로 작업 전후를 확인할 수 있어서 정말 신뢰가 갑니다.', name: '김민지', info: '서울 거주 / 문산읍 선산 관리' },
    { category: '산소', categoryEn: 'grave', rating: 5, headline: '21개 요인 견적이 정말 투명해요', content: '다른 업체는 현장 보고 가격을 부르는데, 여기는 미리 정확한 견적을 받았어요. GPS로 면적까지 재서 보내주니 믿음이 갑니다. 묶음 할인도 합리적이에요.', name: '이정수', info: '집현면 선산 4기 관리' },
    { category: '산소', categoryEn: 'grave', rating: 5, headline: '석축 보수도 전문적으로', content: '오래된 석축이 무너질까 걱정했는데, 전문 기술로 완벽하게 보수해주셨어요. 작업 과정도 사진으로 다 보내주셔서 안심됐습니다. 위성 사진 분석도 감동이었어요.', name: '정민수', info: '명석면 선산 관리' },
  ];

  const filteredTestimonials = activeFilter === 'all' ? testimonials : testimonials.filter(t => t.categoryEn === activeFilter);

  return (
    <section id="testimonials" className="relative py-16 sm:py-28 px-4 sm:px-6 overflow-hidden" style={{background: 'linear-gradient(150deg, #111e3a 0%, #0d1f3c 55%, #152a52 100%)'}}>
      <div className="absolute inset-0 opacity-[0.03]" style={{backgroundImage: 'linear-gradient(110deg, transparent 41%, #c9a227 42%, #c9a227 42.4%, transparent 43%), linear-gradient(78deg, transparent 63%, #c9a227 64%, #c9a227 64.3%, transparent 65%)', backgroundSize: '360px 360px'}}></div>

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Title */}
        <div className="text-center mb-12 sm:mb-18">
          <div className="flex items-center justify-center gap-2 mb-4 sm:mb-5">
            <div className="w-2 h-2 rounded-full bg-[#c9a227]"></div>
            <span className="text-xs sm:text-sm text-[#c9a227]/80 font-medium tracking-wide">고객 만족도 98%</span>
          </div>
          <h2 className="text-2xl sm:text-5xl md:text-6xl font-bold text-white leading-[1.2] tracking-tight mb-4 sm:mb-5">
            진주지역 고객들이 직접 전하는 신뢰의 목소리
          </h2>
          <p className="text-sm sm:text-xl text-white/65 leading-relaxed">
            전원주택부터 산소까지, 투명한 보고와 완벽한 마무리
          </p>
        </div>

        {/* Category Tabs */}
        <div className="flex justify-center gap-4 mb-10 sm:mb-14">
          <div className="inline-flex rounded-full p-1 shadow-sm border border-[#c9a227]/20" style={{background: 'rgba(13,31,60,0.8)'}}>
            {[
              { key: 'all', label: '전체 보기' },
              { key: 'house', label: '전원주택' },
              { key: 'grave', label: '산소·선산' },
            ].map(tab => (
              <button
                key={tab.key}
                onClick={() => setActiveFilter(tab.key as 'all' | 'house' | 'grave')}
                className={`px-4 sm:px-6 py-2 rounded-full text-xs sm:text-sm font-medium whitespace-nowrap cursor-pointer transition-all ${
                  activeFilter === tab.key ? 'text-[#0d1f3c] font-bold shadow-sm' : 'text-white/65 hover:text-white'
                }`}
                style={activeFilter === tab.key ? {background: 'linear-gradient(135deg, #e8c84a, #b8860b)'} : {}}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 sm:gap-7">
          {filteredTestimonials.map((testimonial, index) => (
            <div key={index} className="rounded-2xl p-6 sm:p-8 shadow-sm border border-[#c9a227]/15 transition-all duration-300 hover:shadow-lg hover:-translate-y-2" style={{background: 'linear-gradient(160deg, rgba(30,58,110,0.8), rgba(13,31,60,0.9))'}}>
              <div className="inline-block mb-4">
                <span className={`text-xs font-bold px-3 py-1.5 rounded-full border ${
                  testimonial.category === '전원주택'
                    ? 'bg-[#c9a227]/15 text-[#c9a227] border-[#c9a227]/30'
                    : 'bg-[#c9a227]/10 text-[#c9a227]/80 border-[#c9a227]/20'
                }`}>
                  {testimonial.category} 관리
                </span>
              </div>
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <div key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-[#c9a227] text-sm sm:text-base"></i>
                  </div>
                ))}
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-white mb-3 leading-snug tracking-tight">
                {testimonial.headline}
              </h3>
              <p className="text-sm sm:text-base leading-[1.85] mb-6 text-white/60">
                {testimonial.content}
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-[#c9a227]/10">
                <div className="w-10 h-10 sm:w-11 sm:h-11 rounded-full flex items-center justify-center flex-shrink-0 border border-[#c9a227]/25" style={{background: 'rgba(201,162,39,0.12)'}}>
                  <span className="font-bold text-base sm:text-lg text-[#c9a227]">
                    {testimonial.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <div className="text-sm sm:text-base font-bold text-white tracking-tight">{testimonial.name}</div>
                  <div className="text-xs sm:text-sm text-white/45 mt-0.5">{testimonial.info}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
